export const preventNegativeNumber = (value: number): number => {
  if (value < 0) {
    value = 0;
  }
  return value;
};

export const maxInt = 2147483647;
